import { render } from "./process-reports-chart.vue?vue&type=template&id=7dbf0180&scoped=true&ts=true"
import script from "./process-reports-chart.vue?vue&type=script&lang=ts"
export * from "./process-reports-chart.vue?vue&type=script&lang=ts"

import "./process-reports-chart.vue?vue&type=style&index=0&id=7dbf0180&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbf0180"]])

export default __exports__